import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconMenuButton } from '../../model/icon-menu-button';

@Component({
  selector: 'app-simple-icon-button-menu',
  templateUrl: './simple-icon-button-menu.component.html',
  styleUrls: ['./simple-icon-button-menu.component.scss']
})
export class SimpleIconButtonMenuComponent {

  @Input() horizontaly: boolean = true;

  @Input() menuIcons: IconMenuButton[];

  @Output() buttonClicked: EventEmitter<string> = new EventEmitter();

}
